import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../components/content-box/ContentBox";
import PageActions from "../../../../base/PageActions";
import '../../../../styles/Common.scss';
import '../WorldPages.scss';
import '../WorldDynamicContent.scss';
import Breadcrumbs from "../../../../../components/breadcrumbs/Breadcrumbs";

interface MagicPageProps {
}

const MagicPage = (props: MagicPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok Magic Compendium - Chase the Fox`,
        description: "Magic in Casarok draws from one's life force, known as mana, to cast a wide variety of spells!",
        keywords: ["casarok", "magic", "magic compendium", "magic system", "mana", "life force", "spellcasting"],
        imgSrc: `chase/world/magic/classes/spellcaster.png`,
        url: `world/magic`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Magic Compendium">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <p>
                        Magic has been a driving force in Casarok throughout its long history. Since the first days of
                        intelligent life, mortals have been able to wield magic either through inherently being born
                        with it or learning it through rigorous
                        study. <NavLink className="world-link" to="/world/religion/pantheon">The gods and goddesses</NavLink> of
                        Casarok, on the other hand, have always been able to use magic.
                    </p>
                    <p>
                        Magic is used by drawing from one's own mana, the life force that exists within all creatures.
                        By manipulating one's mana in various methods and quantities, a person can cast a plethora of
                        spells. Mana is a limited resource, however, due to the fact that it draws from the user's
                        life force, the very power that sustains their life. One's mana is depleted when their life
                        force is weakened to the point that drawing from it any further would do damage to the user.
                        Mana can be restored by resting, eating, drinking, or consuming special concoctions or items
                        like mana potions that replenish one's life force.
                    </p>
                    <ol className="spaced">
                        <li>
                            <NavLink className="world-link" to="/world/magic/schools">The Four Schools</NavLink>:
                            All magic is divided into four different schools, each with its own method of casting.
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/elements">The Elements</NavLink>:
                            Spells usually fall into different elements with different properties.
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/classes">Special Classes</NavLink>:
                            Some magic users fall under special classifications.
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/items">Items</NavLink>:
                            Certain items help both spellcasters and non-spellcasters alike use magic.
                        </li>
                        <li>
                            <NavLink className="world-link" to="/world/magic/afflictions">Afflictions</NavLink>:
                            Magic can cause a variety of afflictions to those who are casters of or targeted by spells.
                        </li>
                    </ol>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicPage;